<template>
	<div>
		<div v-for="(item,index) in images" :key="index" class="border upload-div">
			<img :src="config.apiurl+item" class="upload-img">
			<div class="upload-del" @click="delAS(item)">
				<i class="el-icon-delete"></i>
			</div>
		</div>
		<el-upload class="avatar-uploader" multiple :action="config.apiurl + '/api/common/upload'" :show-file-list="false" :on-success="upASs" :before-upload="upABS" align="left">
			<i class="el-icon-plus border upload-div"></i>
		</el-upload>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods:{
			upABS(file) {
				const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			upASs(res, file) {
				let date=[];
				if(this.value!='')
				{
					date=this.value.split(',');
				}
				date.push(res.data.url);
				var o=document.createElement('input');
				o.input=()=>{
					this.$emit('input', this.adrtrans(date));
				}
				o.input();
			},
			delAS(item)
			{
				let date=this.value.split(',');
				date.remove(item);
				var o=document.createElement('input');
				o.input=()=>{
					this.$emit('input', this.adrtrans(date));
				}
				o.input();
			}
		},
		props: {
			value: {
				type: String,
				default: ''
			}
		},
		mounted: function () {
			
		},
		computed:{
			images()
			{
				if(this.value=='')
				{
					return []
				}
				else
				{
					return this.value.split(',');
				}
			}
		}
	}
</script>

<style scoped>
	.upload-div{
		position: relative;
		width: 150px;
		height: 150px;
		line-height: 150px;
		font-size: 20px;
		float: left;
		margin-right: 5px;
	}
	.upload-div:hover .upload-del{
		height: 100%;
	}
	.upload-img{
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}
	.upload-del{
		overflow-y: hidden;
		cursor: pointer;
		position: absolute;
		bottom: 0px;
		left: 0px;
		width: 100%;
		height: 0;
		text-align: center;
		color: white;
		background-color: rgba(0,0,0,0.5);
		background-color: rgb(0,0,0,0.5);
		transition: height 0.5s;
		-moz-transition: height 0.5s;	/* Firefox 4 */
		-webkit-transition: height 0.5s;	/* Safari 和 Chrome */
		-o-transition: height 0.5s;	/* Opera */
	}
	.avatar-uploader{
		border-color: #409EFF;
	}
	.border{
		border: 1px solid #dcdfe6;
		border-radius:4px;
	}
</style>
